import {
    Building2,
    Search,
    UserPlus,
    UserRoundPlus,
    LayoutDashboard,
    Plus,
    Users,
    Menu,
    Navigation,
    Package,
    Pencil,
    Eye,
    Trash2,
    Boxes,
    Layers3,
    ArrowLeft,
    Shield,
    Edit,
    KeyRound,
    CheckCircle2,
    XCircle,
    ChevronRight,
    Check,
    Save,
    Info,
    Link2,
    Hash,
    Tag,
    Loader2,
    TrendingUp,
    FileText,
    Anchor,
    DollarSign,
    Brain,
    ChevronDown,
    ChevronLeft,
    ShoppingCart,
    ShoppingBag,
    Truck,
    BookOpen,
    BarChart3,
    Calculator,
    Settings,
    ShieldCheck,
    Sparkles,
    Ship,
    Grid3X3,
    Code2,
    MessageSquareMore,
    Bot,
    FileQuestion,
    PanelLeftClose,
    PanelLeftOpen,
    X,
    ExternalLink,
    Bell,
    Receipt,
    CreditCard,
    BookMarked,
    Wallet,
    PieChart,
    MapPin,
    Map,
    ScrollText,
    Globe,
    Download,
    Compass,
    Plane,
    RefreshCw,
    CheckCircle,
    Clock,
    Calendar,
    Lock,
    FileCheck,
    AlertCircle,
    Warehouse,
    EyeOff,
    Zap,
    ArrowRight,
    WandSparkles,
    List,
    LayoutGrid,
    BookmarkPlus,
    Activity,
    ArrowUpRight,
    Filter,
    ArrowDownZA,
    ArrowUpAZ,
    RotateCcw,
    ClipboardList,
    ChevronUp,
    Send,
    User,
    AlertTriangle,
    Printer,
    Mail,
    Copy,
    NotepadText,
    SquareMenu,
    Upload,
    UserCheck2,
    Edit2,
    Phone,
    Briefcase

} from "lucide-react";
import MultiCarrierIcon from "./MultiCarrierIcon";

export {
    MultiCarrierIcon,
    Building2,
    WandSparkles,
    Warehouse,
    Search,
    UserPlus,
    UserRoundPlus,
    LayoutDashboard,
    Plus,
    Users,
    Menu,
    Navigation,
    Package,
    Pencil,
    Eye,
    Trash2,
    Boxes,
    Layers3,
    ArrowLeft,
    Shield,
    Edit,
    KeyRound,
    CheckCircle2,
    XCircle,
    ChevronRight,
    Check,
    Save,
    Info,
    Link2,
    Hash,
    Tag,
    Loader2,
    TrendingUp,
    FileText,
    Anchor,
    DollarSign,
    Brain,
    ChevronDown,
    ChevronLeft,
    ShoppingCart,
    ShoppingBag,
    Truck,
    BookOpen,
    BarChart3,
    Calculator,
    Settings,
    ShieldCheck,
    Sparkles,
    Ship,
    Grid3X3,
    Code2,
    MessageSquareMore,
    Bot,
    FileQuestion,
    PanelLeftClose,
    PanelLeftOpen,
    X,
    ExternalLink,
    Bell,
    Receipt,
    CreditCard,
    BookMarked,
    Wallet,
    PieChart,
    MapPin,
    Map,
    ScrollText,
    Globe,
    Download,
    Compass,
    Plane,
    RefreshCw,
    CheckCircle,
    Clock,
    Calendar,
    Lock,
    FileCheck,
    AlertCircle,
    EyeOff,
    Zap,
    ArrowRight,
    List,
    LayoutGrid,
    BookmarkPlus,
    Activity,
    ArrowUpRight,
    Filter,
    ArrowDownZA,
    ArrowUpAZ,
    RotateCcw,
    ClipboardList,
    ChevronUp,
    Send,
    User,
    AlertTriangle,
    Printer,
    Mail,
    Copy,
    NotepadText,
    SquareMenu,
    Upload,
    UserCheck2,
    Edit2,
    Phone,
    Briefcase

};

export const ICON_MAP = {
    WandSparkles,
    Warehouse,
    Building2,
    Search,
    UserPlus,
    UserRoundPlus,
    LayoutDashboard,
    Plus,
    Users,
    Menu,
    Navigation,
    Package,
    Pencil,
    Eye,
    Trash2,
    Boxes,
    Layers3,
    ArrowLeft,
    Shield,
    Edit,
    KeyRound,
    CheckCircle2,
    XCircle,
    ChevronRight,
    Check,
    Save,
    Info,
    Link2,
    Hash,
    Tag,
    Loader2,
    TrendingUp,
    FileText,
    Anchor,
    DollarSign,
    Brain,
    ChevronDown,
    ChevronLeft,
    ShoppingCart,
    ShoppingBag,
    Truck,
    BookOpen,
    BarChart3,
    Calculator,
    Settings,
    ShieldCheck,
    Sparkles,
    Ship,
    Grid3X3,
    Code2,
    MessageSquareMore,
    Bot,
    FileQuestion,
    PanelLeftClose,
    PanelLeftOpen,
    X,
    ExternalLink,
    Bell,
    Receipt,
    CreditCard,
    BookMarked,
    Wallet,
    PieChart,
    MapPin,
    Map,
    ScrollText,
    Globe,
    Download,
    Compass,
    Plane,
    RefreshCw,
    CheckCircle,
    Clock,
    Calendar,
    Lock,
    FileCheck,
    AlertCircle,
    EyeOff,
    Zap,
    ArrowRight,
    List,
    LayoutGrid,
    BookmarkPlus,
    Activity,
    ArrowUpRight,
    Filter,
    ArrowDownZA,
    ArrowUpAZ,
    RotateCcw,
    ClipboardList,
    ChevronUp,
    Send,
    User,
    AlertTriangle,
    Printer,
    Mail,
    Copy,
    NotepadText,
    SquareMenu,
    Upload,
    UserCheck2,
    Edit2,
    Phone,
    Briefcase

};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const resolveIcon = (iconName, defaultIcon = LayoutDashboard) => {
    const key = iconName?.trim();

    return ICON_MAP[key] || defaultIcon;
};

export const iconOptions = ICON_OPTIONS.map((name) => ({
    value: name,
    label: name,
    icon: ICON_MAP[name],
}));
